import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { Input, FormControl, InputLabel, FormHelperText } from '@material-ui/core';
import EditButton from '../atomic/buttons/EditButton';
import SaveButton from '../atomic/buttons/SaveButton';
import CancelButton from '../atomic/buttons/CancelButton';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`;

const Top = styled.div`
    display: flex;
    width: 100%;
`;

const Bottom = styled.div`
    width: 100%;
`;


const StyledFormControl = styled(FormControl)`
    width: 100%;
`

const StyledInput = styled(Input)`
    width: 100%;
    &.disabled {
        color: black !important;
    }
`;

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: space-around;
    width: 60px;
    ${props => {
        if (props.wide) {
            return css`
                width: 125px;
            `;
        }
    }}
`;

/**
 * InputComponent can be a component that adheres to
 * the MaterialUI props for an Input
 */
class EditableLabel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            editing: false,
            value: this.props.defaultValue || '',
            error: null
        }
    }

    componentDidUpdate() {
        if (this.state.editing) {
            this.input.focus()
        }
    }

    handleChange = (event) => {
        this.setState( {value: event.target.value});
    }

    onFinish = async () => {
        try {
            await this.props.onFinish(this.state.value);
            this.endEditing();
        }
        catch (e) {
            this.setState({ error: e.message });
            console.error(e);
        }
    }

    startEditing = () => {
        this.setState({ editing: true });
    }

    endEditing = () => {
        this.setState({ editing: false, error: null });
    }

    cancelEditing = () => {
        this.setState({ value: this.props.defaultValue || '' });
        this.endEditing();
    }

    render() {
        const InputComponent = this.props.inputComponent;
        return (
            <Container>
                <Top>
                    <StyledFormControl >
                        <InputLabel error={!!this.state.error}>{this.props.label}</InputLabel>
                        <StyledInput
                            inputRef={(input) => { this.input = input; }}
                            classes={{
                                disabled: 'disabled' 
                            }}
                            disabled = {!this.state.editing}
                            value = {this.state.value}
                            onChange={this.handleChange}
                            error = {!!this.state.error}
                        />
                    </StyledFormControl>
                        {
                            this.state.editing ?
                                <ButtonWrapper wide>
                                    <SaveButton onClick={this.onFinish} />
                                    <CancelButton onClick={this.cancelEditing} />
                                </ButtonWrapper>
                                :
                                <ButtonWrapper>
                                    <EditButton onClick={this.startEditing} />
                                </ButtonWrapper>
                        }
                </Top>
                <Bottom>
                    <FormHelperText error>{this.state.error}</FormHelperText>
                </Bottom>
            </Container>
        );
    }
}

EditableLabel.propTypes = {
    label: PropTypes.string,
    defaultValue: PropTypes.string,
    onFinish: PropTypes.func.isRequired
};

EditableLabel.defaultProps = {
    label: "",
    defaultValue: "",
};

export default EditableLabel;